import getAgreementById from '../../api/Agreement/getAgreementById.api';
import getAllAgreements from '../../api/Agreement/getAllAgreements.api';
import { getDepositSchedule } from '../../api/Agreement/getDepositSchedule.api';
import getExteriorImage from '../../api/Agreement/getExteriorImage.api';
import getFloorplanImages from '../../api/Agreement/getFloorplanImages.api';
import getOptionsDetails from '../../api/Agreement/getOptionsDetails.api';
import moveLeadToPurchaser from '../../api/Agreement/moveLeadToPurchaser.api';
import removePurchaser from '../../api/Agreement/removePurchaser.api';
import saveAgreementData from '../../api/Agreement/saveAgreementData.api';
import savePersistedData from '../../api/Agreement/savePersistedData.api';
import {
	CLEAR_AGREEMENT_FAIL,
	CLEAR_AGREEMENT_SUCCESS,
	CONVERT_LEAD_FAIL,
	CONVERT_LEAD_SUCCESS,
	GET_AGREEMENT_BY_ID_FAIL,
	GET_AGREEMENT_BY_ID_SUCCESS,
	GET_ALL_AGREEMENTS_SUCCESS,
	GET_DEPOSIT_SCHEDULE_FAIL,
	GET_DEPOSIT_SCHEDULE_SUCCESS,
	GET_OPTION_DETAILS_FAIL,
	GET_OPTION_DETAILS_SUCCESS,
	GO_TO_STEP_FAIL,
	GO_TO_STEP_SUCCESS,
	LOAD_EXTERIOR_FAIL,
	LOAD_EXTERIOR_SUCCESS,
	LOAD_FLOORPLANS_FAIL,
	LOAD_FLOORPLANS_SUCCESS,
	NEXT_ACTIVE_STEP_FAIL,
	NEXT_ACTIVE_STEP_SUCCESS,
	PREVIOUS_ACTIVE_STEP_FAIL,
	PREVIOUS_ACTIVE_STEP_SUCCESS,
	REMOVE_SECOND_CLIENT_FAIL,
	REMOVE_SECOND_CLIENT_SUCCESS,
	RESET_AGREEMENT_FAIL,
	RESET_AGREEMENT_SUCCESS,
	SAVE_AGREEMENT_FAIL,
	SAVE_AGREEMENT_SUCCESS,
	SAVE_PERSISTED_DATA_FAIL,
	SAVE_PERSISTED_DATA_SUCCESS,
	SET_IS_COMPLETE,
	SET_LOADING_FAIL,
	SET_LOADING_SUCCESS,
} from './types';

export const nextActiveStep = () => {
	return async (dispatch) => {
		try {
			var addValue = 1;
			console.log('nextActiveStep');
			dispatch(nextActiveStepSuccess(addValue));
		} catch (error) {
			dispatch(nextActiveStepFail(error));
		}
	};
};

export const previousActiveStep = () => {
	return async (dispatch) => {
		try {
			var substractValue = 1;
			dispatch(previousActiveStepSuccess(substractValue));
		} catch (error) {
			dispatch(previousActiveStepFail(error));
		}
	};
};

export const goToStep = (index) => {
	return async (dispatch) => {
		try {
			dispatch(goToStepSuccess(index));
		} catch (error) {
			dispatch(goToStepFail(error));
		}
	};
};

export const resetAgreement = () => {
	return async (dispatch) => {
		try {
			dispatch(resetAgreementSuccess());
		} catch (error) {
			dispatch(resetAgreementFail(error));
		}
	};
};

export const saveAgreementInfo = (leadId, section, data) => {
	return async (dispatch, getState) => {
		var state = getState();
		try {
			var payload = {
				...state.agreement,
				[section]: data,
			};

			console.log('saveAgreementInfo payload', leadId, section, data);

			saveAgreementData(leadId, section, data);

			dispatch(saveAgreementInfoSuccess(payload));
		} catch (error) {
			dispatch(saveAgreementInfoFail(error));
		}
	};
};

export const getAgreementDataById = (leadId) => {
	return async (dispatch) => {
		try {
			getAgreementById(leadId, (returned) => {
				console.log('getAgreementDataById payload', returned);
				dispatch(getAgreementByIdSuccess(returned));
			});
		} catch (error) {
			dispatch(getAgreementByIdFail(error));
		}
	};
};

export const loadExteriorImg = (modelHome, elevation) => {
	return async (dispatch) => {
		try {
			// console.log('loadExteriorImg');
			getExteriorImage(modelHome, elevation, (returned) =>
				dispatch(loadExteriorImgSuccess(returned))
			);
		} catch (error) {
			dispatch(loadExteriorImgFail(error));
		}
	};
};

export const loadFloorplanImgs = (modelHome, elevation) => {
	return async (dispatch) => {
		try {
			getFloorplanImages(modelHome, elevation, (returned) => {
				console.log('loadFloorplanImgs returned', returned);
				dispatch(loadFloorplanImgSuccess(returned));
			});
		} catch (error) {
			dispatch(loadFloorplanImgFail(error));
		}
	};
};

export const clearAgreement = () => {
	return async (dispatch) => {
		try {
			dispatch(clearAgreementSuccess());
		} catch (error) {
			dispatch(clearAgreementFail(error));
		}
	};
};

export const removeClient = (leadId, id) => {
	return async (dispatch) => {
		try {
			removePurchaser(leadId, id);
			dispatch(removeClientSuccess({}));
		} catch (error) {
			dispatch(removeClientSuccess(removeClientFail));
		}
	};
};

export const getOptionDetails = (modelName, elevation) => {
	return async (dispatch) => {
		try {
			getOptionsDetails(modelName, elevation, (returned) => {
				dispatch(getOptionDetailsSuccess(returned));
			});
		} catch (error) {
			dispatch(getOptionDetailsFail(error));
		}
	};
};

export const setLoading = (payload) => {
	return async (dispatch) => {
		try {
			dispatch(setLoadingSuccess(payload));
		} catch (error) {
			dispatch(setLoadingFail(error));
		}
	};
};

export const persistData = (section, data) => {
	return async (dispatch) => {
		try {
			var data = savePersistedData(section, data);
			dispatch(setPersistedDataSuccess(data));
		} catch (error) {
			dispatch(setPersistedDataFail(error));
		}
	};
};

export const getDepositScheduleAPI = (leadId) => {
	return async (dispatch) => {
		try {
			getDepositSchedule(leadId, (data) => {
				dispatch(getDepositScheduleAPISuccess(data));
			});
		} catch (error) {
			dispatch(getDepositScheduleAPIFail(error));
		}
	};
};

export const getDepositScheduleAPISuccess = (payload) => ({
	type: GET_DEPOSIT_SCHEDULE_SUCCESS,
	payload,
});

export const getDepositScheduleAPIFail = (payload) => ({
	type: GET_DEPOSIT_SCHEDULE_FAIL,
	payload,
});
export const setPersistedDataSuccess = (payload) => ({
	type: SAVE_PERSISTED_DATA_SUCCESS,
	payload,
});

export const setPersistedDataFail = (payload) => ({
	type: SAVE_PERSISTED_DATA_FAIL,
	payload,
});

export const setLoadingSuccess = (payload) => ({
	type: SET_LOADING_SUCCESS,
	payload,
});
export const setLoadingFail = (payload) => ({
	type: SET_LOADING_FAIL,
	payload,
});

const resetAgreementSuccess = (payload) => ({
	type: RESET_AGREEMENT_SUCCESS,
	payload,
});

const resetAgreementFail = (payload) => ({
	type: RESET_AGREEMENT_FAIL,
	payload,
});

const getOptionDetailsSuccess = (payload) => ({
	type: GET_OPTION_DETAILS_SUCCESS,
	payload,
});

const getOptionDetailsFail = (payload) => ({
	type: GET_OPTION_DETAILS_FAIL,
	payload,
});

const removeClientSuccess = (payload) => ({
	type: REMOVE_SECOND_CLIENT_SUCCESS,
	payload,
});

const removeClientFail = (payload) => ({
	type: REMOVE_SECOND_CLIENT_FAIL,
	payload,
});

const nextActiveStepSuccess = (payload) => ({
	type: NEXT_ACTIVE_STEP_SUCCESS,
	payload,
});

const nextActiveStepFail = (payload) => ({
	type: NEXT_ACTIVE_STEP_FAIL,
	payload,
});

const previousActiveStepSuccess = (payload) => ({
	type: PREVIOUS_ACTIVE_STEP_SUCCESS,
	payload,
});

const previousActiveStepFail = (payload) => ({
	type: PREVIOUS_ACTIVE_STEP_FAIL,
	payload,
});

const goToStepSuccess = (payload) => ({
	type: GO_TO_STEP_SUCCESS,
	payload,
});

const goToStepFail = (payload) => ({
	type: GO_TO_STEP_FAIL,
	payload,
});

const saveAgreementInfoSuccess = (payload) => ({
	type: SAVE_AGREEMENT_SUCCESS,
	payload,
});

const saveAgreementInfoFail = (payload) => ({
	type: SAVE_AGREEMENT_FAIL,
	payload,
});

const loadExteriorImgSuccess = (payload) => ({
	type: LOAD_EXTERIOR_SUCCESS,
	payload,
});

const loadExteriorImgFail = (payload) => ({
	type: LOAD_EXTERIOR_FAIL,
	payload,
});

const loadFloorplanImgSuccess = (payload) => ({
	type: LOAD_FLOORPLANS_SUCCESS,
	payload,
});

const loadFloorplanImgFail = (payload) => ({
	type: LOAD_FLOORPLANS_FAIL,
	payload,
});

const clearAgreementSuccess = (payload) => ({
	type: CLEAR_AGREEMENT_SUCCESS,
	payload,
});

const clearAgreementFail = (payload) => ({
	type: CLEAR_AGREEMENT_FAIL,
	payload,
});

const getAgreementByIdSuccess = (payload) => ({
	type: GET_AGREEMENT_BY_ID_SUCCESS,
	payload,
});
const getAgreementByIdFail = (payload) => ({
	type: GET_AGREEMENT_BY_ID_FAIL,
	payload,
});
